<template>
	<div v-if="files.length > 0 && showUploadList">
		<div v-if="!showFileList" class="position-absolute ab-notification-card">
			<section
				style="border-radius: 12px 12px 0 0"
				class="d-flex align-items-center ab-notification-card-header px-3"
			>
				<img src="@/assets/asset-bank/uploadicon.svg" alt="" />

				<img
					v-if="totalProgress < 100"
					src="@/assets/asset-bank/tabler_loader.svg"
					class="ml-2 loader-icon"
					alt="Uploading"
				/>
				<img
					v-else-if="totalProgress == 100"
					src="@/assets/course-structure/green-tick.svg"
					class="ml-2"
					alt="Upload Complete"
				/>

				<div class="w-90 ml-2">
					<p class="ab-noti-upload-txt" v-if="totalProgress < 100">
						Uploading {{ files.length }}
						{{ files.length == 1 ? "Item" : "Items" }}
					</p>
					<div class="d-flex align-items-center">
						<p class="ab-noti-text">{{ totalFileSize }}</p>
						<p class="ab-noti-text ml-2" v-if="totalTimeRemaining">
							{{ totalTimeRemaining }} left
						</p>
					</div>
				</div>

				<img
					@click="toggleFileList"
					src="@/assets/common/down-arrow.svg"
					alt=""
					class="pointer"
				/>
			</section>
		</div>

		<div
			v-else
			class="position-absolute ab-notification-card d-flex align-items-center flex-column"
		>
			<section
				style="border-radius: 12px 12px 0 0"
				class="d-flex align-items-center ab-notification-card-header px-3"
			>
				<img src="@/assets/asset-bank/uploadicon.svg" alt="" />

				<img
					v-if="totalProgress < 100"
					src="@/assets/asset-bank/tabler_loader.svg"
					class="ml-2 loader-icon"
					alt="Uploading"
				/>
				<img
					v-else-if="totalProgress == 100"
					src="@/assets/course-structure/green-tick.svg"
					class="ml-2"
					alt="Upload Complete"
				/>
				<div class="w-90 ml-2">
					<p class="ab-noti-upload-txt">
						Uploading {{ files.length }}
						{{ files.length == 1 ? "Item" : "Items" }}
					</p>
					<div class="d-flex align-items-center">
						<p class="ab-noti-text">{{ totalFileSize }}</p>
						<p class="ab-noti-text ml-2" v-if="totalTimeRemaining">
							{{ totalTimeRemaining }} left
						</p>
					</div>
				</div>
				<img
					class="pointer"
					@click="toggleFileList"
					src="@/assets/common/up-arrow.svg"
					alt=""
				/>
			</section>
			<section class="notification-card-body overflow-xh-ya pb-2">
				<b-row class="mt-3" v-for="(file, index) in files" :key="index">
					<b-col class="ab-uploaded-card mx-3">
						<b-card no-body class="d-flex">
							<section class="d-flex align-items-center">
								<img
									src="@/assets/asset-bank/listview/card-doc-icon.svg"
									class="mr-2"
									alt="File icon"
								/>
								<div class="d-flex flex-column w-80">
									<div
										class="ab-uploaded-file-heading d-flex align-items-center"
									>
										{{ file.fileName }}
									</div>
									<div class="ab-uploaded-file-subheading">
										<span>{{ formatSize(file.fileSize) }}</span>
										<span class="ml-4" v-if="file.timeRemaining"
											>{{ file.timeRemaining }}&nbsp;left</span
										>
									</div>
								</div>

								<div class="ml-2 d-flex align-items-center">
									<img
										@click="openModal(index)"
										src="@/assets/common/expand-icon.svg"
										alt=""
										class="mr-2 pointer"
									/><img
										@click.stop="stopUpload(index)"
										src="@/assets/common/delete.svg"
										alt="Delete "
										class="pointer"
									/>
								</div>
							</section>
							<section class="mt-1">
								<b-progress height="4px" :value="file.progress"></b-progress>
							</section>
						</b-card>
					</b-col>
				</b-row>
			</section>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/utils/eventBus";
import { required } from "vuelidate/lib/validators";
import toast from "@/mixins/toast";

// import axios from "axios";

export default {
	mixins: [toast],

	props: {
		showUploadList: Boolean,
	},
	data() {
		return {
			showList: false,
			totalTimeRemaining: "",
			uploadedFileData: {},
			uploadId: "",
			editedIndex: null,
			notificationvisible: true,
			notinumber: 5,
			estimatedTimeRemaining: "",
			uploadProgress: 0,
			showFileList: true,
			addnewfile: false,
			fileData: {},
			videoLength: null,
		};
	},
	validations() {
		return {
			fileData: {
				title: {
					required,
				},
			},
		};
	},

	created() {
		eventBus.$on("assetUploadSuccess", this.handleAssetUploadSuccess);
	},

	computed: {
		totalProgress() {
			if (this.files.length === 0) return 0;
			const totalProgress = this.files.reduce(
				(acc, file) => acc + file.progress,
				0
			);
			return totalProgress / this.files.length;
		},
		...mapGetters("assetVUEX", {
			files: "getUploadedFiles",
			socket: "getUploadSocket",
		}),
		totalFileSize() {
			const totalBytes = this.files.reduce(
				(total, file) => total + file.fileSize,
				0
			);
			return this.formatSize(totalBytes);
		},
	},
	watch: {
		files: {
			handler(newFiles) {
				newFiles.forEach((file) => {
					if (file.progress === 100) {
						setTimeout(() => {
							this.$store.commit(
								"assetVUEX/REMOVE_COMPLETED_FILE_USING_TEMP_ID",
								file.fileData.tempId
							);
						}, 2000);
					}
				});

				if (this.editedIndex !== null && newFiles.length > this.editedIndex) {
					this.uploadProgress = newFiles[this.editedIndex].progress;
					this.estimatedTimeRemaining =
						newFiles[this.editedIndex].timeRemaining;
				}
				if (this.files.length === 0) return "";
				const totalTime = this.files.reduce(
					(total, file) => total + file.estimatedTimeRemaining,
					0
				);

				this.totalTimeRemaining = this.formatTime(totalTime);
			},
			deep: true,
			immediate: true,
		},
	},

	mounted() {
		window.addEventListener("beforeunload", this.handleBeforeUnload);
	},
	beforeDestroy() {
		window.removeEventListener("beforeunload", this.handleBeforeUnload);
	},
	methods: {
		openModal(index) {
			this.$emit("open-modal", index);
			eventBus.$emit("indexSelected", index);
		},
		formatTime(seconds) {
			if (isNaN(seconds) || seconds <= 0) return "";

			const h = Math.floor(seconds / 3600);
			const m = Math.floor((seconds % 3600) / 60);
			const s = Math.floor(seconds % 60);

			const formattedParts = [];
			if (h > 0) formattedParts.push(`${h}h`);
			if (m > 0) formattedParts.push(`${m}min`);
			if (s > 0 || formattedParts.length === 0) formattedParts.push(`${s}sec`);

			return formattedParts.join(" ");
		},

		handleAssetUploadSuccess() {
			eventBus.$emit("uploadComplete");
		},
		beforeDestroy() {
			eventBus.$off("assetUploadSuccess", this.handleAssetUploadSuccess);
		},
		async stopUpload(index) {
			try {
				if (this.socket) {
					this.socket.disconnect();
					this.$store.commit("assetVUEX/clearSocket");
				}
				this.uploadProgress = 0;
				this.estimatedTimeRemaining = "";
				eventBus.$emit("reset-method");
				this.files.splice(index, 1);
				this.successToast("File Deleted Successfully");
				// }
			} catch (error) {
				console.error("Error deleting file:", error);
			}
		},
		handleBeforeUnload(event) {
			if (this.files.length > 0) {
				const message = "Changes you made may not be saved.";
				event.returnValue = message;
			}
		},

		formatSize(bytes) {
			if (bytes === 0) return "0 MB";
			const k = 1024;
			const sizeInMB = bytes / (k * k);
			return parseFloat(sizeInMB).toFixed(2) + " MB";
		},

		toggleFileList() {
			this.showFileList = !this.showFileList;
		},
	},
};
</script>

<style>
@keyframes rotateLoader {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}

.loader-icon {
	animation: rotateLoader 1s linear infinite;
}
</style>
